import { render, staticRenderFns } from "./Article-type.vue?vue&type=template&id=4c6a15a7&scoped=true"
import script from "./Article-type.vue?vue&type=script&lang=js"
export * from "./Article-type.vue?vue&type=script&lang=js"
import style0 from "./Article-type.vue?vue&type=style&index=0&id=4c6a15a7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a15a7",
  null
  
)

export default component.exports